module.exports = __webpack_public_path__ + "static/media/solomons-seal-summer-xl.4a984b20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/solomons-seal-summer-xl.jpg
// module id = 416
// module chunks = 12